var Curriculog = Curriculog || {};

Curriculog.CommitteesToolboxView = (function ($, _, Backbone, CommitteesToolboxView) {

    CommitteesToolboxView = Curriculog.ToolboxBaseView.extend({
        template: 'HierarchyToolbox/committeesToolbox.html',
        toolboxType: 'committee',

        events: {
            'input #committee-name': 'checkName',
            'click #committee-create': 'createCommittee',
            'click #committee-update': 'update',
            'click #committee-cancel': 'cancel',
            'click .edit-widget': 'edit',
            'click .delete-widget:not(.disabled)': 'delete',
            'click .delete-widget.disabled': 'disabledDeleteButton',
        },

        initialize: function (options) {
            this.editingType = null;
            this.committees = options.committees;
            this.listenTo(this.committees, 'add', this.updateList);
            this.listenTo(this.committees, 'remove', this.updateList);
            this.listenTo(this.committees, 'change', this.updateList);
            this.render();
        },

        render: function () {
            templateData = {
                committees: this.committees.toJSON(),
            };

            this.el = nunjucks.render(this.template, templateData);
            this.replaceElement(this.el);
        },

        getClickedModel: function (event) {
            var elementID = $(event.target).closest('li').attr('id');
            var committeeID = elementID.split('-')[1];
            return this.committees.get(committeeID);
        },

        createCommittee: _.debounce(function () {
            var view = this;
            var name = $(this.el).find('#' + this.toolboxType + '-name').val();

            if (name.length > 0) {
                this.committees.create({
                    name: name,
                    type: 'committee',
                    status: 'active',
                    canDelete: true,
                }, {
                    wait: true,

                    error: function () {
                        var errorText = 'An error was encountered when creating the committee.  ';
                        errorText += 'Please try again or contact an administrator.';
                        view.showGrowl(errorText);
                    },
                });
            }
        }, 250),
    });
    return CommitteesToolboxView;

})($, _, Backbone, Curriculog.CommitteesToolboxView || {});
